export default __webpack_public_path__ + "static/media/ascii_small_matrix.a5f422b1.png";